export default "/images/ac836e986e06dff65d5f2179cc6aac61.avif";